import styled from 'styled-components';

export const ContainerStyled = styled.div`
  background: ${({theme}) => theme === 'dark' ? '#2A2927' : '#F5F7FA' };
  display: flex;
  flex-direction: column;
  flex: 1;

  .main-container{
    flex: 1;
    min-height: 500px;
  }

  footer {
    margin-top: 60px;
  }
`;
